import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import './NavMenu.css';
import linkedIn from "../assets/images/linkedin.png";
import gitHub from "../assets/images/github.png";

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm bg-dark navbar-dark border-bottom box-shadow mb-3" light={false}>
                    <Container>
                        <div>
                            <NavbarBrand tag={Link} to="/">Jzo.blog</NavbarBrand>
                            <a href="https://www.linkedin.com/in/jzo001/" target="_blank" title="Visit my LinkedIn profile" rel="noopener noreferer">
                                <img src={linkedIn} width="21" height="21" alt="LinkedIn" />
                            </a>
                        </div>
                        <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                        <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                            <ul className="navbar-nav flex-grow">
                                <NavItem>
                                    <NavLink tag={Link} className="navbar-dark" to="/">Blog</NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink tag={Link} className="navbar-dark" to="/forgedocs">Forge.Docs</NavLink>
                                </NavItem>
                                <a href="https://github.com/JZO001/Forge" target="_blank" title="Visit my GitHub projects" rel="noopener noreferer">
                                    <img className="githubImg" src={gitHub} width="21" height="21" alt="GitHub" />
                                </a>
                            </ul>
                        </Collapse>
                    </Container>
                </Navbar>
            </header>
        );
    }
}
